let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("S52rf")).then(() => parcelRequire('58gQo'));